import React from 'react'
import { Link } from 'react-router-dom'
import AndhraLogo from "../assets/Andhra-logo.png"


const Footer = () => {
  return (
    <div className="footer_container">
      <div className="footer_imgs">
        <div className="footer_logo">
          <a href="https://www.andhrauniversity.edu.in/" target="_blank" rel="noreferrer">
            <img src={AndhraLogo} alt="Andhra Logo" />
          </a>
        </div>
        <div className="footer_counter">
          <p>
            Andhra University is not just one of the oldest educational institutions in the country, but is also the first to be conceived as a residential and teaching-cum-affiliating University, mainly devoted to post-graduate teaching and research.


          </p>

          <div className="website_counter">
          <img
            src='//clustrmaps.com/map_v2.png?cl=c4bbbb&t=tt&d=eiekn8CWruIqEVJr5R4KyadnYpdtYw1T2s0vE2Oc0cU&co=f5f5f5&ct=000000' alt="Visitor map" />

          </div>

          
        </div>

      </div>

      <div className="footer_menu">
        <Link to="/acknowledgement" onClick={() => window.scrollTo(0, 0)}>Acknowledgement</Link>
        <Link to="/disclaimer" onClick={() => window.scrollTo(0, 0)}>Disclaimer</Link>
        <a href='https://clustrmaps.com/site/1bvb7' target='_blank' rel="noreferrer">Website Visitors</a>
        <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
      </div>
      <div className="copyright_container">
        <p>Copyright © 2023 Andhra University. All rights reserved.</p>
      </div>

    </div>
  );
};

export default Footer;
